import { render, staticRenderFns } from "./B2BView.vue?vue&type=template&id=5872b1d7&scoped=true"
import script from "./B2BView.vue?vue&type=script&lang=js"
export * from "./B2BView.vue?vue&type=script&lang=js"
import style0 from "./B2BView.vue?vue&type=style&index=0&id=5872b1d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872b1d7",
  null
  
)

export default component.exports